const merge = require('deepmerge');
const fingerprint = require('../../../utils/Fingerprint');
let _parsed = false;

/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class ServerParser {

    static parseLaunch(launcherConfig) {
        return {
            rgsApi: launcherConfig.platform,
            launchParams: {
                gameId: launcherConfig.gameId,
                lang: launcherConfig.lang,
            }
        };
    }

    static parse(cfg) {
        if (_parsed){
            return cfg.server;
        }
        _parsed = true;
        cfg.server.launchParams.userData = merge(cfg.server.launchParams.userData, { fingerprint: fingerprint() });
        return cfg.server;
    }
}

module.exports = ServerParser;
